<template>
    <div>
        <v-card class="overflow-hidden v-card v-sheet theme--light mt-0 px-0" style="max-width: 100% !important;">
            <!-- Alert Messages -->
            <div>
                <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
            </div>
            <!-- ######## Main page ######## -->
            <HeaderComponent :headerTitle="headerText" :router-link="{ name: 'PRD' }"
             :router-link-text="action_title"  :return-condition="true" :component-name="prd_number"></HeaderComponent>
            <!-- <HeaderComponent :headerTitle="headerText" :IrrdDetails="IrrdDetails" :tagNumber="tagNumber"/> -->

            <!-- search, Action buttons -->
            <v-card class="v-card-100 mt-0" v-if="action == 'IRD' || action == 'IRRD' || action == 'create_prd' || action == 'upload_prd'">
                <v-card-title class="action-style pb-0">
                <v-row class="ma-3 mb-0">
                <!-- Search fields -->
                <v-autocomplete class="text-left mr-4" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;"> </v-autocomplete>
                <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" :disabled="!select_field" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData()" ></v-text-field>
                <v-spacer></v-spacer>
                <!-- Actions buttons -->
                    <v-btn  color="primary" size="x-large" @click="downloadthis" class="mb-7 mr-2 text-none" v-if="action != 'create_prd' && action != 'upload_prd'">Download</v-btn>
                    <v-btn  color="primary" size="x-large" @click="printThis" class="mb-7 mr-2 text-none" v-if="action != 'create_prd' && action != 'upload_prd'">Print</v-btn>
                    <v-btn  color="primary" size="x-large" @click="emailThis" class="mb-7 mr-2 text-none" v-if="action != 'create_prd' && action != 'upload_prd'">E-mail</v-btn>
                    <v-btn  color="primary" size="x-large" class="mb-7 mr-2 text-none" v-if="action == 'create_prd' ||  action == 'upload_prd'" @click="uploadDocum">Upload</v-btn>
                </v-row>
                </v-card-title>
            </v-card>

            <!--Name, Price and Creation Date-->
            <v-card class="v-card-100" v-if="action == 'IRD' || action == 'IRRD'">
                <v-row>
                    <v-col cols="4" class="text-center">
                        <span style="font-weight: 500;" >Vendor Name: {{ vendor_name }}</span>
                    </v-col>
                    <v-col cols="4" class="text-center">
                        <span style="font-weight: 500;" >Purchase Price: (₹) {{ formattedPurchasePrice }}</span>
                    </v-col>
                    <v-col cols="4" class="text-center">
                        <span style="font-weight: 500;">Creation Date: {{ creation_date }}</span>
                    </v-col>
                </v-row>
            </v-card>

            <!-- Data Table -->
            <v-layout column  v-if="action == 'IRD' || action == 'IRRD' || action == 'create_prd' || action == 'upload_prd'">
                <!-- <v-flex md6 style="overflow: auto"> -->
                    <v-data-table hover
                        density="compact"
                        :headers="headers"
                        :items="table_data"
                        :items-per-page="pageSize"
                        disable-pagination 
                        :hide-default-footer="true"
                        :loading="loading" 
                        fixed-header
                        height="100%"
                        loading-text="Loading Data... Please wait"
                        class="elevation-1">
                        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
                            <span v-if="header.key == 'status'">
                                <span v-if="item.status == 'Completed'">{{ item.status  }} 
                                <v-icon color="success" size="18">mdi-alert-circle</v-icon>
                                </span>
                                <span v-else-if="item.status == 'Halted'">{{ item.status  }} 
                                    <v-icon color="warning" size="18">mdi-alert-circle</v-icon>
                                </span>
                                <span v-else-if="item.status == 'Failed'">{{ item.status  }} 
                                    <v-icon color="error" size="18">mdi-alert-circle</v-icon>
                                </span>
                                <span v-else-if="!item.status">Pending</span>
                                <span v-else>{{ item.status }}</span>
                            </span> 
                            <span v-else-if="header.key == 'remarks' && item[header.key]">
                                <a href="#" @click.prevent="showError(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">View Error</a>
                            </span>
                            <span v-else-if="header.key !== 'images' && item[header.key]">
                                <span v-tooltip="item[header.key]">
                                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                                </span>
                            </span>
                            
                            <span v-else-if="header.key == 'org_file'">
                                <v-btn  variant="outlined" class="cancel-color my-1 text-none" color="primary" @click="downloadDocum(item)">Download</v-btn>
                            </span>
                            <span v-else>-</span>
                        </template>
                        
                        
                        <!-- <template #[`item.org_file`]="{ item }">
                            <v-btn  variant="outlined" class="cancel-color my-1 text-none" color="primary" @click="downloadDocum(item)">Download</v-btn>
                        </template> -->
                        <!-- <template #[`item.status`]="{ item }">
                            <span v-if="item.status == 'Completed'">{{ item.status  }} 
                                <v-icon color="success" size="18">mdi-alert-circle</v-icon>
                            </span>
                            <span v-else-if="item.status == 'Halted'">{{ item.status  }} 
                                <v-icon color="warning" size="18">mdi-alert-circle</v-icon>
                            </span>
                            <span v-else-if="item.status == 'Fail'">{{ item.status  }} 
                                <v-icon color="error" size="18">mdi-alert-circle</v-icon>
                            </span>
                            <span v-else-if="!item.status">Pending</span>
                            <span v-else>{{ item.status }}</span>
                        </template> -->
                        <!-- <template #[`item.ird_number`]="{ item }">
                            <span>{{ item.ird_number ? item.ird_number : '-'}}</span>
                        </template> -->
                        <!-- <template #[`item.remarks`]="{ item }">
                            <span v-if="item.remarks"><a style="text-decoration:underline; color:#007BFF" @click="showError(item)" class="cursor-pointer">View Error</a></span>
                            <span v-else>-</span> -->
                            <!-- <span>{{ item.remarks ? <a style="text-decoration:underline; color:#007BFF">View Error</a> : "-" }}</span> -->
                        <!-- </template> -->
                        <template #bottom></template>
                    </v-data-table>
                <!-- </v-flex> -->
            </v-layout>

            <!-- pagination display -->
            <!-- <v-container fluid v-if="action == 'IRD' || action == 'IRRD' || action == 'create_prd' || action == 'upload_prd'">
              <v-row class="m-0">
                <v-col cols="12" class="d-flex justify-space-between gap-3">
                  <div style="width: 6rem;">
                    <v-select v-model="pageSize" :items="pageSizes" variant="underlined" label="Items per page" @update:modelValue="handlePageSizeChange"></v-select>
                  </div>
                  <span class="item-selected"> <span v-if="selected.length == 1">{{selected.length}} Item Selected</span> <span v-if="selected.length > 1">{{selected.length}} Items Selected</span> </span>
                  <v-col cols="12" sm="4" class="PaddingItemPerPage d-flex justify-end">
                      <v-pagination density="comfortable" elevation="2" v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right" prev-icon="mdi-menu-left" active-color="bg-primary" @update:modelValue="handlePageChange"></v-pagination>
                  </v-col>
                </v-col>
              </v-row>
            </v-container> -->
            
            <v-row class="ml-2 py-4">
              <span class="PaddingItemPerPage d-flex mt-3">
                <label class="" style="margin-top: -2px;">Rows Per Page</label>
                <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
                variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
              </span>

              <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
              <v-spacer></v-spacer>
              <div class="d-flex">
                <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                  - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
                <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px !important' : 'auto'">
                  <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                  @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                </span>
              </div>
            </v-row>
            <!-- File Upload popup -->
        <v-row justify="center">
            <v-dialog v-model="fileUploadPopup" persistent max-width="424px">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex align-center">
                        <span v-if="action == 'create_prd'">Create PRD</span>
                        <span v-if="action == 'upload_prd'">Upload Csv FiLle</span>
                        <v-spacer></v-spacer>
                        <v-btn variant="solo" icon @click="cancelUploadFile">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider :thickness="4" class="m-0" />
                    <v-card-text>
                        <v-container>
                            <div class="pb-3">
                                <span v-if="action !== 'upload_prd'"  style="color: #007BFF;float: right; font-size: smaller;" @click="downloadSampleFile">Download PRD Sample File</span>
                            </div>
                            <v-file-input
                                v-model="upload_file"
                                label="Attach Csv file"
                                @upload_file="changeFile"
                                style="margin-top: 28px;"
                                accept=".csv"
                                :error="fileError"
                                :error-messages="fileErrorMessage"
                                clear-icon="mdi-close"
                                variant="underlined" 
                                class="upload input-text_overflow-ellipsis"
                            >
                            </v-file-input>
                            <div v-if="uploading">
                                Uploading file ({{ uploadPercentage }}%)
                                <v-progress-linear
                                :model-value="uploadPercentage"
                                color="blue"
                                height="10"
                                ></v-progress-linear>
                            </div>
                        </v-container>
                    </v-card-text>
                    <v-card-actions center>
                        <v-spacer></v-spacer>
                        <v-btn variant="flat" color="primary" class="mb-3 text-none" v-if="this.confirmButton != 'FINISH'" @click="confirmUploadFile" :disabled="!upload_file || number>0">Confirm</v-btn>
                        <v-btn variant="flat" color="primary" class="mb-3 text-none" v-if="this.confirmButton == 'FINISH'" @click="clickFinish" :disabled="!upload_file || number>0">Finish</v-btn>
                        <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" v-if="cancel_button_hide === false" :disabled="number > 0" @click="cancelUploadFile">Cancel</v-btn>   
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- message popup -->
        <v-row justify="center">
            <v-dialog v-model="messagePopup" persistent :max-width="messagePopWidth">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex align-center">
                        <span></span>
                        <v-spacer></v-spacer>
                        <v-btn variant="solo" icon @click="messagePopup = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span>{{ message }}</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" class="text-none" variant="flat" @click="loadData" v-if="action_name == 'success_msg'">Ok</v-btn>
                        <v-btn color="primary" class="text-none" variant="flat" @click="downloadError" v-if="action_name == 'download_error'">Download</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- e-mail popup -->
        <v-row justify="center">
            <v-dialog v-model="emailPopup" persistent max-width="424px">
                <v-card class="v-card-100">
                    <v-card-title class="d-flex align-center">
                        <span>Email ID</span>
                        <v-spacer></v-spacer>
                        <v-btn variant="solo" icon @click="emailPopup = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider :thickness="4" class="m-0" />
                    <v-card-text>
                        <div v-for="(email , index) in emailIds" :key="index">
                            <span v-if="index ==0 ">
                                <v-text-field color="primary" label = "Enter Email ID" v-model="email.email_id" variant="outlined" class="mt-5" :rules="[validateEmail]"></v-text-field>
                            </span>
                            <span v-else>
                                <v-text-field color="primary" label = "Enter Email ID" v-model="email.email_id" variant="outlined" :rules="[validateEmail]"></v-text-field>
                            </span>
                        </div>
                        <span style="text-decoration:underline; color:#007BFF" @click="add_more_emailId">Add More</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :color="isSendButtonDisabled() ? 'secondry' : 'primary'" variant="flat" class="mb-3 text-none" :disabled="isSendButtonDisabled()" @click="sendEmail">Send</v-btn>  
                        <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="emailPopup = false">Cancel</v-btn>  
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- Complete PRD Details -->
        <v-card v-if="action == 'Incomplete PRD\'s'">
            <v-card-text class="pa-8">
                <v-row>
                    <v-col cols="4">
                        <span style="font-weight: bold;">Update Details</span>
                    </v-col>
                    <v-col cols="8">
                        <v-row>
                            <v-col cols="6" v-for="item in item_schema" :key="item">
                                <span v-if="item.type == 'dropDown'">
                                    <v-autocomplete color="primary" :label="item.label" v-model="item.value" :items="location_list" item-title = "code" item-value = "id" variant="outlined"></v-autocomplete>
                                </span>
                                <span v-else-if="item.type == 'textField'">
                                    <span v-if="item.key == 'asp' || item.key == 'sales_price' || item.key == 'estimated_loss' || item.key == 'mrp'|| item.key == 'map' || item.key == 'purchase_price'">
                                        <v-text-field color="primary" :label="item.label+ ' (₹)'" v-model="item.value" variant="outlined"  @input="formatCurrencyOnInput(item)"></v-text-field>
                                    </span>
                                    <span v-else>
                                        <v-text-field color="primary" :label="item.label" v-model="item.value" variant="outlined"></v-text-field>
                                    </span>
                                </span>
                                <span v-else-if="item.type == 'date'">
                                    <v-menu v-model="item.openDatePopup" :close-on-content-click="false"
                                     transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ props }">
                                            <v-text-field color="primary" :model-value="formattedDate(item)" :label="item.label" variant="outlined"
                                                append-inner-icon="mdi-calendar" readonly v-bind="props">
                                            </v-text-field>
                                        </template>
                                       
                                         <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                                          <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="item.datePickerDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                                          </v-date-picker>
                                          <v-card-action class="d-flex justify-end pb-3">
                                            <v-spacer></v-spacer>
                                            <v-btn variant="text" color="primary" @click="handleCancel(item)">Cancel</v-btn>
                                            <v-btn variant="text" color="primary" @click="handleSaveDate(item)">OK</v-btn>
                                          </v-card-action>
                                        </v-card>
                                    </v-menu>
                                </span>
                                <span v-else-if="item.type == 'checkBoxButton'" style="display: flex;">
                                    <span class="mb-0 mt-4" style="font-size: 16px;">{{ item.label }}</span>
                                    <v-checkbox v-model="item.value" label="True" value="true" class="ml-15 mt-3"></v-checkbox>
                                    <v-checkbox v-model="item.value" label="False" value="false" class="ml-15 mt-3"></v-checkbox>
                                </span>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mb-7 mr-4 text-none" @click="submitUpdateDetails" :disabled="checkDisablebility">Submit</v-btn>
            </v-card-actions>
        </v-card>
        </v-card>

        
    </div>
</template>
<script>
import $ from 'jquery';
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { mixinHelper } from "@//mixins/mixin-helper.js";
export default {
  mixins: [mixinHelper],
    components: {
        HeaderComponent,
    },
    data(){
        return {
        headerText: "PRD",
        prd:true,
        search_tag:'',
        IrrdDetails:true,
        loading: false,
        alert: false,
        alert_type: "success",
        alert_message: "success",
        headers : [],
        table_data : [],
        page : 1,
        pageSize : 25,
        pageSizes : [25,50,75,100],
        totalPages : 1,
        item_details : '',
        prd_number : '',
        irrdNumTodfetchData : '',
        vendor_name : '',
        purchase_price : '',
        creation_date : '',
        action : '',
        fileUploadPopup : false,
        upload_file : '',
        uploading: false,
        confirmButton:'CONFIRM',
        number: 0,
        uploadPercentage: 0,
        messagePopup : false,
        messagePopWidth:'',
        action_name : '',
        file_name_for_error : '',
        message : '',
        action_title : '',
        totalCount: '',
        tab_name : '',
        emailIds : [],
        selected: [],
        emailPopup : false,
        location_list : [],
        item_id : '',
        prd_item_details: '',
        select_field:null,
        select_field_items: [
        {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"IRRD",
                "id": "irrd_number"
              },
              {
                "name":"Serial Number",
                "id": "serial_number"
              },
        ],
        cancel_button_hide: false,
        item_key : {
                'tag_number' : 'Tag Number',
                'box_number' : 'Box Number',
                'brand' : 'Brand',
                'model' : 'Model',
                'scan_indicator' : 'Scan Indicator',
                'imei_flag' : 'IMEI Flag',
                'serial_number1' : 'Serial Number 1',
                'serial_number2' : 'Serial Number 2',
                'quantity' : 'Quantity',
                'mrp' : 'MRP',
                'asp' : 'ASP',
                'sales_price' : 'Sales Price',
                'map' : 'MAP',
                'purchase_price' : 'Purchase Price',
                'type_of_damage' : 'Types Of Damage',
                'type_of_loss' : 'Types Of Loss',
                'estimated_loss' : 'Estimated Loss',
                'purchase_invoice_number' : 'Purchase Invoice Number',
                'doa_certificate_number' : 'DOA Certificate Number',
                'supplying_site_id' : 'Supplying Site',
                'receiving_site_id' : 'Receiving Site',
                'brand_approval_required' : 'Brand Approval',
                'buyer_available' : 'Buyer Available',
                'prd_number' : 'PRD Number',
                'incident_date' : 'Incident Date',
                'sales_invoice_date' : 'Sales Invoice Date',
                'installation_date' : 'Installation date',
                'purchase_date' : 'Purchase Date',
                'purchase_invoice_date' : 'Purchase Invoice Date',
                'doa_certificate_date' : 'DOA Certificate Date',
            },
        item_schema : [],
        menu_141: false,
        selectedDate : '',
        fileErrorMessage:'',
        fileError: false,
        organization_name:'',
        error_url:'',
        }
    },
    async created(){
        this.action = this.$store.state.action;
        const item_detail = JSON.parse(this.$store.state.items);
        this.tab_name = this.$store.state.tab_name
        this.organization_name = this.$store.state.organization_name;
        if(this.action == 'create_prd' || this.action == 'upload_prd'){
            this.prd_number = (this.action == 'create_prd') ? 'Create PRD' : 'Upload PRD';
            this.action_title = 'Incomplete PRD'
        } else if(this.action == 'IRRD'){
            this.prd_number = item_detail.irrd_number;
            this.action_title = this.action;
        }else if(this.action == 'IRD'){
            this.prd_number = item_detail.ird_number;
            this.action_title = this.action;
        }else {
            this.prd_number = 'Update Information';
            this.item_id =  item_detail.id
            this.action_title = this.action;
            this.irrdNumTodfetchData = item_detail.irrd_number;
            this.getLocationData();
            this.getPrdDetails();
        }
        this.loadData();
    },
    computed : {
        checkDisablebility(){
            return !this.item_schema.some( x => x.value);
        },
        formattedPurchasePrice() {
            return this.formatCurrency(this.purchase_price)
        },
        formattedPurchasePrice(){
            return this.formatCurrency(this.purchase_price)
        }
    },
    methods : {
        formatCurrency(value) {
            return Number(value).toLocaleString('en-IN');
        },
        formatCurrencyOnInput(item) {
            item.value = parseFloat(item.value.replace(/[^0-9.]/g, '')).toLocaleString('en-IN');
        },
        loadData(){
            this.loading = true;
            this.messagePopup = false;
            if(this.action == 'IRRD'){
                this.headers = [
                    {title: "IRD No.", key: "ird_number"},
                    {title: "Tag ID", key: "tag_number", sortable:false},
                    {title: "Article ID", key: "sku_code"},
                    {title: "Article Description", key: "sku_description"},
                    {title: "Serial Number", key: "serial_number1"}
                ]
            this.fetchIRRDData();
            } else if(this.action == 'IRD'){
                this.headers = [
                    {title: "Article ID", key: "sku_code"},
                    {title: "Article Description", key: "sku_description"},
                    {title: "Serial Number", key: "serial_number1"}
                ]
            this.fetchIRDData();
            } else if(this.action == 'create_prd'){
                this.headers = [
                    {title: "ID", key: "id"},
                    {title: "File", key: "filename"},
                    {title: "Type", key: "file_type"},
                    {title: "Status", key: "status"},
                    {title: "Uploaded Date & Time", key: "updated_at"},
                    {title: "Remarks", key: "remarks"},
                    {title: "Original File", key: "org_file"}
                ] 
                this.fetchCreatePRDIndexData();
            } else if(this.action == 'upload_prd'){
                this.headers = [
                    {title: "ID", key: "id"},
                    {title: "File", key: "filename"},
                    {title: "Type", key: "file_type"},
                    {title: "Status", key: "status"},
                    {title: "Uploaded Date & Time", key: "updated_at"},
                    {title: "Remarks", key: "remarks"},
                    {title: "Original File", key: "org_file"}
                ] 
                this.fetchUploadIndexData();
            }
        },
        fetchIRRDData(){
            this.purchase_price = 0;
            const params = {
                search : this.search_tag,
                page : this.page,
                per_page : this.pageSize
            }
            const tab_status = this.tab_name == 'Approval' ? 'Pending Approval' : this.tab_name
            const api = '/api/v1/warehouse/prd/get_irrd_items?status='+tab_status+'&irrd_number='+this.prd_number
            this.$httpSecured
            .get(api,{ params : params })
            .then(response => {
                this.table_data = response.data.pending_receipt_document_items;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                if(this.table_data.length > 0){
                    this.creation_date = this.table_data[0].created_date
                    this.vendor_name = this.table_data[0].vendor_name
                    this.table_data.forEach( x=> { this.purchase_price+= x.purchase_price; })
                }
                this.loading = false;
            })
            .catch(error => {
                this.number = 0;
                this.$toast.error(error.response.data.message);
            }); 
        },
        fetchIRDData(){
            this.purchase_price = 0;
            const params = {
                search : this.search_tag,
                page : this.page,
                per_page : this.pageSize
            }
            const tab_status = this.tab_name == 'Approval' ? 'Pending Approval' : this.tab_name
            const api = '/api/v1/warehouse/prd/get_ird_items?status='+tab_status+'&ird_number='+this.prd_number
            this.$httpSecured
            .get(api,{ params : params })
            .then(response => {
                this.table_data = response.data.pending_receipt_document_items;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                if(this.table_data.length > 0){
                    this.creation_date = this.table_data[0].created_date
                    this.vendor_name = this.table_data[0].vendor_name
                    this.table_data.forEach( x => { this.purchase_price+= x.purchase_price; })
                }
                this.loading = false;
            })
            .catch(error => {
                this.number = 0;
                this.$toast.error(error.response.data.message);
            }); 
        },
        fetchCreatePRDIndexData(){
            const params = {
                page : this.page,
                per_page : this.pageSize
            }
            if(this.search_tag){
                params[this.select_field] = this.search_tag
            }
            this.$httpSecured
            .get('/api/v1/warehouse/prd/file_uploads',{ params : params })
            .then(response => {
                this.table_data = response.data.master_file_uploads;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false;
            })
            .catch(error => {
                this.number = 0;
                this.loading = false;
                this.$toast.error(error.response.data.message);
            }); 
        },
        fetchUploadIndexData(){
            const params = {
                search : this.search_tag,
                page : this.page,
                per_page : this.pageSize
            }
            this.$httpSecured
            .get('/api/v1/warehouse/prd/file_uploads?file_type=Update PRD Items',{ params : params })
            .then(response => {
                this.table_data = response.data.master_file_uploads;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false;
            })
            .catch(error => {
                this.number = 0;
                this.$toast.error(error.response.data.message);
            }); 
        },
        downloadthis(){
            const api_link = (this.action == 'IRRD') ? 'download_irrd_items' : 'download_ird_items';
            const irrd_type = (this.action == 'IRRD') ? 'irrd_number' : 'ird_number';
            this.$httpSecured.
            get('/api/v1/warehouse/prd/'+api_link+'?status='+this.tab_name+'&'+irrd_type+'='+this.prd_number,
                {
                responseType: 'blob'
                }
            )
            .then(response => {
            if (response.data) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.prd_number}-Items.csv`);
                document.body.appendChild(link);
                link.click();
                this.messagePopup = true;
                this.action_name = 'success_msg';
                this.message = String(this.prd_number)+" - Downloaded Successfully";
                this.messagePopWidth = "424px"
            }
            })
            .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
        printThis(){
            window.print();
        },
        uploadDocum(){
            this.fileUploadPopup = true;
            this.fileErrorMessage = '';
            this.fileError = false;
            this.confirmButton='CONFIRM';
            this.upload_file = null;
            this.cancel_button_hide = false;
        },
        cancelUploadFile(){
            this.fileUploadPopup = false;
            this.number = 0;
            this.upload_file = '';
            this.uploadPercentage = 0;
            this.uploading = false;
        },
        confirmUploadFile(){
            this.uploadFile('start')
            this.number++;
            const formData = new FormData();
            formData.append('file' , this.upload_file);
            if(this.action == 'upload_prd'){
                formData.append('file_type' , "Update PRD Items");
            }
            this.$httpSecured
            .post('/api/v1/warehouse/prd/upload_file', formData )
                .then(response => {
                // this.fileUploadPopup = false;
                // this.messagePopup = true;
                this.uploadFile('success')
                this.action_name = 'success_msg';
                this.message = "PRD Successfully Initiated";
                this.messagePopWidth = "424px"
                })
                .catch(error => {
                    this.number = 0;
                    this.$toast.error(error.response.data.message);
                });  
        },
        changeFile(){
            if (this.upload_file) {
                const fileType = this.upload_file.type;
                if (fileType !== 'text/csv' && fileType !== 'application/vnd.ms-excel') {
                    this.fileError = true;
                    this.fileErrorMessage = 'Only CSV files are allowed.';
                    this.upload_file = null;
                } else {
                    this.fileError = false;
                    this.fileErrorMessage = '';
                }
            } else {
                this.confirmButton = 'CONFIRM';
            }
        },
        uploadFile(status) {
            var percentage;
            this.uploading = true;
            let reader = new FileReader();
             if(status === 'start'){
                 reader.onprogress = (event) => {
                if (event.lengthComputable) {
                    percentage = Math.round((event.loaded / event.total) * 50);
                    this.uploadPercentage = percentage;
                }
            };
             }else if(status === 'success'){
                reader.onprogress = (event) => {
                if (event.lengthComputable) {
                 percentage = Math.round((event.loaded / event.total) * 100);
                 this.uploadPercentage = percentage;
                 this.cancel_button_hide = true;               
                }
            };
             }
            reader.onloadend = (event) => {
                if(status === 'success'){
                setTimeout(() => {
                this.uploading = false;
                this.uploadPercentage = 0;
                this.number = 0;
                this.confirmButton = 'FINISH';
                }, 2000);
                }                
            };
            
            reader.readAsDataURL(this.upload_file);
        },
        clickFinish(){
            this.fileUploadPopup = false;
            this.loadData();            
        },
        downloadDocum(item){
            if(item.payload && item.file_type === "Pending Receipt Document API"){
                const jsonData = JSON.stringify(item.payload, null, 2);
                const blob = new Blob([jsonData], { type: 'text/plain' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.file_name || 'data'}.txt`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }else{
                const link = document.createElement('a');
                link.href = item.master_file_url;
                link.setAttribute('download', `${item.filename}`);
                document.body.appendChild(link);
                link.click();
            }
            this.action_name = 'success_msg';
            this.message = item.filename + " Downloded Successfully!";
            this.messagePopWidth = "424px"
            this.messagePopup = true;
        },
        handlePageChange(value) {
            this.page = value;
            this.loadData();
        },
        handlePageSizeChange(size) {
            this.pageSize = size;
            this.page = 1
            this.loadData();
        },
        showError(item){
            this.error_url = item.error_file ? item.error_file : item.master_file_url
            this.messagePopup = true;
            this.message = item.remarks;
            const temp = item.filename.split('.')
            this.file_name_for_error = temp[0]
            this.messagePopWidth = "850px";
            this.action_name = 'download_error';
        },
        downloadError(){
            const url = window.URL.createObjectURL(new Blob([this.message.split(',').join('\n')]));
            const link = document.createElement('a');
            if((this.action == 'create_prd' && this.$isRelianceClient()) || (this.action == 'upload_prd' && this.$isRelianceClient())){
               link.href = this.error_url ? this.error_url : url;
            }else{
              link.href = url;
            }
            link.setAttribute('download', `${this.file_name_for_error}_error.txt`);
            document.body.appendChild(link);
            link.click();
            this.action_name = 'success_msg';
            this.message = "Error Downloaded Successfully Completed";
            this.messagePopWidth = "424px"
        },
        emailThis(){
            this.emailPopup = true;
            this.emailIds= [{ email_id : '' }];
        },
        add_more_emailId(){
            this.emailIds.push({email_id : ''});
        },
        validateEmail(value) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!value) {
                return 'This Field is Required'
            }
            if (!regex.test(value)) {
                return 'Not a valid email address.';
            }
            const domain = value.split('.').pop();
            if (domain.toLowerCase() !== 'com') {
                return 'Please use a .com email address.';
            }
            return null;
        },
        isSendButtonDisabled() {
            return this.emailIds.some((email) => {
                const trimmedEmail = email.email_id.trim();
                const validationError = this.validateEmail(trimmedEmail);
                return !trimmedEmail || validationError;
            });
        },
        sendEmail(){
            const api_link = (this.action == 'IRRD') ? 'download_irrd_items' : 'download_ird_items';
            const irrd_type = (this.action == 'IRRD') ? 'irrd_number' : 'ird_number';
            var emails = [];
            this.emailIds.forEach( x => { emails.push(x.email_id)});
            const params = {
                "email_ids":emails
            }
            this.$httpSecured.
            get('/api/v1/warehouse/prd/'+api_link+'?send_email=true&status='+this.tab_name+'&'+irrd_type+'='+this.prd_number,
                { params : params }
            )
            .then(response => {
            if (response.data) {
                this.emailPopup = false;
                this.action_name = 'success_msg';
                this.message = response.data.message;
                this.messagePopWidth = "424px"
                this.messagePopup = true;
            }
            })
            .catch(error => {
                this.$toast.error(error.response.data.error);
            });
        },
        downloadSampleFile(){
            var api;
            if(this.action == 'create_prd'){
                api = "/api/v1/warehouse/prd/download_prd_sample"
            } else {
                api = "/api/v1/warehouse/prd/download_prd_sample?upload=true"
            }
            this.$httpSecured
            .get(api)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const file_name = (this.action == 'create_prd') ? 'Create PRD Sample' : 'Upload PRD Sample';
                    link.setAttribute('download', `${file_name}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    this.$toast.success("PRD Sample file downloaded!");
                })
                .catch(error => {
                    this.number = 0;
                    this.$toast.error(error.response.data.message);
                });
        },
        getLocationData(){
            this.$httpSecured
            .get("/api/v1/warehouse/prd/filters_data")
                .then(response => {
                if (response.data) {
                    this.location_list = response.data.locations
                }
            })
                .catch(error => {
                    this.$toast.error(error.response.data.error);
            });
        },
        getPrdDetails(){
            this.$httpSecured
            .get("/api/v1/warehouse/prd/"+this.item_id)
                .then(response => {
                if (response.data) {
                    this.prd_item_details = response.data.prd_item
                    this.item_schema = [];
                    for( var key in this.prd_item_details){
                        if(!this.prd_item_details[key]){
                            if(key == 'supplying_site_id' || key == 'receiving_site_id'){
                                this.item_schema.push({'key' : key, 'label' : this.item_key[key], 'type' : 'dropDown', 'value' : ''})
                            } else if(key.includes('date')){
                                this.item_schema.push({'key' : key, 'label' : this.item_key[key], 'type' : 'date', 'value' : '', 'openDatePopup' : false})
                            } else if(key == 'brand_approval_required'){
                                this.item_schema.push({'key' : key, 'label' : this.item_key[key], 'type' : 'checkBoxButton', 'value' : ''})
                            } else {
                              if(key.includes('date')){
                                this.item_schema.push({'key' : key, 'label' : this.item_key[key], 'type' : 'textField', 'value' : '', datePickerDate: new Date()})
                              }else{
                                this.item_schema.push({'key' : key, 'label' : this.item_key[key], 'type' : 'textField', 'value' : ''})
                              }
                            }
                        }
                    }
                }
            })
                .catch(error => {
                    this.$toast.error(error.response.data.error);
            });
        },
        submitUpdateDetails(){
            // this.item_schema.forEach( x => {this.prd_item_details[x.key] = x.value;})
            this.item_schema.forEach(x => {
                if (x.key === 'sales_price' || x.key === 'estimated_loss' || x.key == 'asp' || x.key == 'mrp' || x.key == 'map' || x.key == 'purchase_price') {
                    let numericValue = parseFloat(x.value.replace(/[^0-9.]/g, ''));
                    this.prd_item_details[x.key] = Math.round(numericValue);
                } else {
                    this.prd_item_details[x.key] = x.value;
                }
            });
            this.$httpSecured
            .put("/api/v1/warehouse/prd/"+this.item_id, { "prd_item": this.prd_item_details })
                .then(response => {
                if (response.data) {        
                    this.$store.commit("showMessage",{
                        alert_type : 'success',
                        alert_message : response.data.message
                    });
                    this.$router.push({ name: 'PRD' });
                }
            })
                .catch(error => {
                    this.$toast.error(error.response.data.error);
            });
        },
        formattedDate(item){
            if (item.value) {
                const temp = item.value
                return temp.split('-').reverse().join('/')
            }
            return '';
        },
        handleCancel(item){
            item.value = '';
            item.datePickerDate = new Date()
            item.openDatePopup = false;
        },
         handleSaveDate(item){
            item.value = this.formatted_filter_date(item.datePickerDate);
            item.openDatePopup = false;
        },
    }

}
</script>
<style scoped>
 @media (max-height: 1104px) {
        .PaddingItemPerPage{
            padding: 8px !important;
        }
    }
    @media (min-height: 1126px) {
        .PaddingItemPerPage{
            padding: 24px !important;
        }
    }
    .v-data-table {
        height: calc(var(--vh, 1vh) * 100 - 312px) !important;
    }
</style>